import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Floating bottom-right actions:
 *  - WhatsApp (number comes from admin → Appearance settings via /api/config)
 *  - Quick Order shortcut to /standard_crackers_pricelist
 *
 * Hidden on admin and quick-order routes (where it would overlap controls).
 */
export function FloatingActions() {
  const [wa, setWa] = useState("");
  const location = useLocation();

  useEffect(() => {
    api.get("/config").then((r) => {
      setWa((r?.data?.whatsapp_number || "").replace(/[^0-9]/g, ""));
    }).catch(() => {});
  }, []);

  const path = location.pathname || "";
  if (path.startsWith("/admin") || path.startsWith("/standard_crackers_pricelist") || path.startsWith("/quick-order")) {
    return null;
  }

  const waUrl = wa
    ? `https://wa.me/${wa}?text=${encodeURIComponent("Hi! I'd like to place an order from Hyderabad Crackers.")}`
    : null;

  return (
    <div
      data-testid="floating-actions"
      className="fixed right-4 bottom-20 md:bottom-6 z-40 flex flex-col items-end gap-3 pointer-events-none"
    >
      <Link
        to="/standard_crackers_pricelist"
        data-testid="floating-quick-order"
        aria-label="Open quick order"
        className="pointer-events-auto group flex items-center gap-2 bg-hyd-gold text-hyd-bg font-bold uppercase tracking-widest text-xs px-4 h-12 rounded-full shadow-glow-gold hover:scale-105 transition-transform"
      >
        <ShoppingBag className="w-4 h-4" />
        <span className="hidden sm:inline">Quick Order</span>
      </Link>

      {waUrl && (
        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="floating-whatsapp"
          aria-label="Chat on WhatsApp"
          className="pointer-events-auto w-14 h-14 rounded-full grid place-items-center text-white shadow-xl hover:scale-105 transition-transform"
          style={{ background: "#25D366" }}
        >
          <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
            <path d="M19.11 17.21c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.22-.65.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.63-.93-2.23-.24-.58-.49-.5-.68-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.28.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.12 3.24 5.14 4.55.72.31 1.28.5 1.72.64.72.23 1.37.2 1.89.12.58-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.07-.13-.27-.2-.57-.35zM16.03 5.33c-5.9 0-10.7 4.8-10.7 10.7 0 1.88.5 3.72 1.44 5.33L5.4 26.67l5.47-1.37a10.65 10.65 0 005.16 1.32h.01c5.9 0 10.7-4.8 10.7-10.7 0-2.86-1.11-5.55-3.13-7.57a10.64 10.64 0 00-7.58-3.02zm0 19.63c-1.63 0-3.22-.44-4.61-1.26l-.33-.2-3.25.82.87-3.16-.22-.33a8.86 8.86 0 01-1.36-4.73c0-4.9 4-8.9 8.9-8.9 2.38 0 4.61.93 6.29 2.61a8.84 8.84 0 012.61 6.29c0 4.9-4 8.9-8.9 8.9z" />
          </svg>
        </a>
      )}
    </div>
  );
}
